import type { FieldValues, FieldPath } from "react-hook-form";
import { ErrorMessage, SelectField } from "@clarityos/ui";
import type { SelectFieldProps } from "@clarityos/ui";
import { FormField } from "./FormField";

type OmittedKeys = "name" | "value" | "onChange" | "onBlur" | "state" | "helper";

interface FormSelectFieldProps<
  TFieldValues extends FieldValues,
  TName extends FieldPath<TFieldValues>,
> extends Omit<SelectFieldProps, OmittedKeys> {
  name: TName;
}

export function FormSelectField<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>({ name, ...selectProps }: FormSelectFieldProps<TFieldValues, TName>) {
  return (
    <FormField
      name={name}
      render={({ value, onChange, onBlur, errorMessage, disabled }) => (
        <SelectField
          {...selectProps}
          name={name}
          value={value ?? ""}
          onChange={onChange}
          onBlur={onBlur}
          disabled={selectProps.disabled || disabled}
          state={errorMessage ? "error" : "default"}
          helper={
            errorMessage ? <ErrorMessage message={errorMessage} /> : undefined
          }
        />
      )}
    />
  );
}
